app.controller("CalendarEventEditController", [
    "$scope", "CalendarEventsService", "$state", "toastr", "StaticData", "$stateParams",
    function ($scope, CalendarEventsService, $state, toastr, StaticData, $stateParams) {
        if ($stateParams.calendarEventId) {
            CalendarEventsService.getById({
                id: $stateParams.calendarEventId
            }).then(function (calendarEvent) {
                $scope.faculty = calendarEvent.faculty;
                $scope.title = calendarEvent.title;
                $scope.description = calendarEvent.description;
                $scope.time = new Date(calendarEvent.time);
                $scope._id = calendarEvent._id;
                $scope.hstep = 1;
                $scope.mstep = 10
            });
        }

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
        });

        $scope.edit = function () {
            CalendarEventsService.edit({
                _id: $scope._id,
                faculties: $scope.faculty,
                title: $scope.title,
                description: $scope.description,
                time: $scope.time,
            }).then(function () {
                toastr.success('', 'ღონისძიება რედაქტირებულია');
                $state.go('admin.calendar-events')
            }).catch(function () {
                toastr.error('', 'ღონისძიების რედაქტირებისას დაფიქსირდა შეცდომა');
            })
        };
    }
]);